export const INVITATION_TYPE_VK_TEAMS = 'vk_teams';
export const INVITATION_TYPE_SMS = 'sms';
export const INVITATION_TYPE_EMAIL = 'email';
export const INVITATION_TYPE_BOTH = 'both';

export type InvitationTypeValue =
  | typeof INVITATION_TYPE_VK_TEAMS
  | typeof INVITATION_TYPE_SMS
  | typeof INVITATION_TYPE_EMAIL
  | typeof INVITATION_TYPE_BOTH;
